import { render, staticRenderFns } from "./ProfileUrlTab.vue?vue&type=template&id=600e2fea"
import script from "./ProfileUrlTab.vue?vue&type=script&lang=js"
export * from "./ProfileUrlTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports